var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "browser" }, [
      _c("div", { staticClass: "top" }, [
        _c("p", { staticClass: "title" }, [_vm._v("果城行丨南充实时公交")]),
        _vm._v(" "),
        _c("p", { staticClass: "mark" }, [
          _vm._v("即时查看公交到站信息 "),
          _c("span", [_vm._v("合理出行")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mark" }, [_vm._v("查车乘车一站式服务")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tips" }, [
        _c("p", { staticClass: "info-mark" }, [
          _vm._v("请使用微信扫描此二维码")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddcc4950", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddcc4950","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/miniUrl/alipay.vue
// module id = null
// module chunks = 